<template>
  <div id="func-53">
    <div id="tab">
      <agendaTab :initial-value="dataInicial" v-model="dataSelecionada" :width="95" :itens="lista"/>
    </div>
    <div id="agenda">
      <span class="title title-agenda" v-if="dataSelecionada">{{formatData(dataSelecionada)}} - {{parseDateName(dataSelecionada)}}</span>
      <el-card v-for="(item, i) in prestadores" :key="i" :style="`background: ${corPrimariaAlpha}`" class="card-horarios-medico">
        <div class="clicked" @click="openDetalhe(item)">
        <el-row>
          <el-col :span="20" class="info-medico">
              <span class="title title-min">{{item.nome}}</span>
              <span class="subtitle-min">{{item.conselho}}</span>
              <span v-if="item.localAtendimento" class="subtitle-min">{{item.localAtendimento.descricao}}</span>
            <div class="btns-horarios">
              <el-button
                class="btn"
                v-for="(horario, i) in item.horarios.slice(0,maxItens)"
                @click.stop="nextStep(item, horario)"
                :style="`background: ${corPrimaria}`"
                :key="i">
                {{formatHora(horario.dataHora)}}
              </el-button>
              <el-button
                v-if="item.horarios.length > maxItens"
                :style="`background: ${corPrimaria}`"
                class="btn"
                @click="openDetalhe(item)">
                + {{ item.horarios.length - maxItens}}
              </el-button>
            </div>
          </el-col>
          <el-col v-if="item.urlFoto" :span="4" class="foto-medico">
            <img class="img-medico" :src="item.urlFoto"/>
          </el-col>
        </el-row>
          <div class="pop-up">
            <el-card v-show="item.alerta"
                     :style="`border: 1px solid ${corSecundaria};
                border: 1px solid ${corSecundaria};
                background-color: #FFFFFF`" class="warning">
              <div style="display: flex; justify-content: space-between">
                      <span class="text-color-small" :style="'color:' + corSecundaria ">
                       {{item.alerta}}</span>
                <el-button @click.stop="removeAlerta(item)" class="btn-close" type="text">
                  <inline-svg class="float-right" :fill="corSecundaria" height="16" :src="require('@/assets/icons/Icon_box_close.svg')"></inline-svg>
                </el-button>
              </div>
            </el-card>
          </div>
        </div>
      </el-card>
      <DialogDefault
        ref="formularioModal"
        :closeOnClickModal="false"
        :open.sync="openDialog"
        :destroy="true"
        :title="titulo"
        :width="'85%'"
        @close="openDialog = false"
      >
        <div>
          <medico-detalhe v-if="openDialog" :active="dataSelecionada" :agenda="agendas"/>
        </div>
      </DialogDefault>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import AgendaTab from '@/components/AgendaTab/AgendaTab'
import moment from 'moment'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import MedicoDetalhe from '@/components/MedicoDetalhe/MedicoDetalhe'
import InlineSvg from 'vue-inline-svg'
export default {
  components: { MedicoDetalhe, AgendaTab, DialogDefault, InlineSvg },
  data () {
    return {
      lista: [],
      dataSelecionada: '',
      dataInicial: null,
      prestadores: [],
      data: '',
      maxItens: 10,
      openDialog: false,
      agendas: null
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('Func53', ['paciente', 'idEspecialidade', 'idLocal', 'idAgenda', 'idServico', 'listaLocal']),
    corPrimariaAlpha () {
      return this.estilo.aplicacao.corPrimariaAplicacao + '1A'
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    titulo () {
      return 'Detalhes do médico'
    },
    corSecundaria () {
      return `${this.estilo.aplicacao.corSecundariaAplicacao}`
    },
    corSecundariaAlpha () {
      return `${this.estilo.aplicacao.corSecundariaAplicacao}1A`
    }
  },
  watch: {
    dataSelecionada: function (newVal, oldVal) {
      if (newVal) {
        this.getAgenda()
      }
    }
  },
  methods: {
    ...mapActions('Func53', ['setAgendamento', 'setIdLocal', 'setLocalAtendimento']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    async getAgenda () {
      const payload = {
        paciente: this.paciente,
        tipoAgenda: this.idAgenda,
        idEspecialidade: this.idEspecialidade,
        data: this.dataSelecionada
      }

      if (this.idLocal) {
        payload.idLocal = this.idLocal
      }

      if (this.idServico) {
        payload.idServico = this.idServico
      }
      const res = await this.apiFuncionalidade.listaAgendasProfissionais({
        payload,
        loading: true
      })
      this.prestadores = res.data.profissionaisAgendas[0].profissionais

      res.data.profissionaisAgendas.forEach(el => {
        this.lista.push(el.data)
      })
    },
    async removeAlerta (item) {
      const i = this.prestadores.findIndex(el => el.id === item.id)
      this.$set(this.prestadores[i], 'alerta', false)
    },
    async openDetalhe (medico) {
      let idMedico = parseInt(medico.id, 10)
      let idEspecialidade = parseInt(medico.especialidade.id, 10)
      this.getAgendaMedico(idMedico, idEspecialidade)
    },
    buscaLocal (medicoIdLocal) {
      if (this.idLocal) {
        return
      }

      const local = this.listaLocal.find(
        local => local.id === medicoIdLocal
      )
      if (!local) {
        return
      }

      this.setIdLocal(local.id)
      this.setLocalAtendimento({
        id: local.id,
        descricao: local.descricao,
        endereco: local.endereco
      })
    },
    async getAgendaMedico (idMedico, idEspecialidade) {
      const payload = {
        paciente: this.paciente,
        tipoAgenda: this.idAgenda,
        idLocal: this.idLocal,
        idEspecialidade: idEspecialidade.toString(),
        idProfissional: idMedico.toString()
      }
      if (this.idServico) {
        payload.idServico = this.idServico.toString()
      }
      const result = await this.apiFuncionalidade.listaAgendasProfissionais({
        payload,
        loading: true
      })
      this.agendas = result.data.profissionaisAgendas
      if (this.agendas) {
        this.openDialog = true
      }
    },
    formatData (data) {
      return moment(data.toString()).format('DD/MM')
    },
    formatHora (val) {
      return moment(val.toString()).format('HH:mm')
    },
    parseDateName (value) {
      const today = moment().format('YYYY-MM-DD')
      if (moment(today).isSame(moment(value))) {
        return 'Hoje'
      } else {
        const data = moment(value.toString(), 'YYYY-MM-DD HH:mm:ss')
        return data.locale('pt-br').format('dddd')
      }
    },
    seeMore (val) {
      this.getAgenda(val)
      this.dataSelecionada = val
    },
    nextStep (item, hora) {
      this.buscaLocal(item.localAtendimento.id)
      const obj = { ...item, ...hora }
      delete obj.horarios
      this.setAgendamento(obj)
      this.$router.replace({ query: { step: 6 } })
    }
  },
  async mounted () {
    this.SET_CURRENT_STEP(4)
    await this.getAgenda()
    this.dataSelecionada = this.lista[0]
    this.dataInicial = this.lista[0]
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.el-tabs__active-bar {
  background-color: var(--cor-primary);
}
div.el-tabs__nav.is-top {
 bottom: 7px;
}
.reset {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  text-transform: none;
}
.clicked {
  cursor: pointer;
}
#tab {
  margin-left: 20px;
}
</style>
